<app-navbar></app-navbar>
 <section class="py-7 ">
  <div class="container">
    <div class="row ">
      <div class="offset-xl-2 col-xl-8 offset-lg-1 col-lg-10 col-md-12 col-12">
        <div class="text-center mb-5">
          <h1 class=" display-2 fw-bold"> Explore Touch Connect</h1>
          <p class=" lead">

Experience the ease of Touch Connect, your personalized hub for centralized content sharing. Simplify your online presence effortlessly with a sleek, organized platform.
          </p>
        </div>

      </div>
    </div>
  </div>
</section>

<section class="pb-8">
  <div class="container">
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-6 col-6 d-flex" *ngFor="let post of sessionDataArray" >
        <!-- Card -->
        <div class="card mb-4 shadow-lg">
          <a  class="card-img-top"   [routerLink]="['/showPostsdetail', post.id]">
              <!-- Img  -->
            <img src="{{post.image}}" class="card-img-top rounded-top-md"  alt="blogpost"></a>
          <!-- Card body -->
          <div class="card-body">

            <h3>
              <a  class="text-inherit"  [routerLink]="['/showPostsdetail', post.id]" >
               {{post.title}}
              </a>
            </h3>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
